<kodit-page [showCardBlock]="showCardBlock">
    <kodit-table
      [tableConfig]="tableConfig"
      [items]="tekuciRacunTable"
      [isTableLoading]="isLoading"
    >
    </kodit-table>
  </kodit-page>
